import styled from 'styled-components';

export const StatsTopWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  margin: 2em 0;
`;
